import { render, staticRenderFns } from "./ItemIndex.vue?vue&type=template&id=aa8e1018&scoped=true"
import script from "./ItemIndex.vue?vue&type=script&lang=js"
export * from "./ItemIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e1018",
  null
  
)

export default component.exports